// extracted by mini-css-extract-plugin
var _1 = "BlotErrorBoundaryFallback-module__animateUploadProgressBarWidth--HJf3c";
var _2 = "BlotErrorBoundaryFallback-module__animatedBackground--g4Fho";
var _3 = "BlotErrorBoundaryFallback-module__block--sQTb9";
var _4 = "BlotErrorBoundaryFallback-module__container--Lj_Yw";
var _5 = "BlotErrorBoundaryFallback-module__content--JLxVR";
var _6 = "BlotErrorBoundaryFallback-module__icon--wR4D_";
var _7 = "BlotErrorBoundaryFallback-module__message--wjinK";
export { _1 as "animateUploadProgressBarWidth", _2 as "animatedBackground", _3 as "block", _4 as "container", _5 as "content", _6 as "icon", _7 as "message" }
